document.addEventListener('DOMContentLoaded', function() {
    // Step 1: Append the external script to the DOM
    var eswScript = document.createElement('script');
    eswScript.type = 'text/javascript';
    eswScript.src = 'https://service.force.com/embeddedservice/5.0/esw.min.js';
    eswScript.defer = true;
    document.body.appendChild(eswScript);

    // Step 2: After the script is appended and loaded, execute the init script
    eswScript.onload = function() {
        var initESW = function(gslbBaseURL) {
            embedded_svc.settings.displayHelpButton = true; // Or false
            embedded_svc.settings.language = ''; // For example, enter 'en' or 'en-US'
            embedded_svc.settings.enabledFeatures = ['LiveAgent'];
            embedded_svc.settings.entryFeature = 'LiveAgent';

            embedded_svc.init(
                'https://backyardproducts.my.salesforce.com',
                'https://backyardproducts.my.site.com/',
                gslbBaseURL,
                '00D41000000FeLR',
                'Heartland_Sheds_Chat',
                {
                    baseLiveAgentContentURL: 'https://c.la1-core2.sfdc-lywfpd.salesforceliveagent.com/content',
                    deploymentId: '5725d000000Rozi',
                    buttonId: '5735d000000JT2N',
                    baseLiveAgentURL: 'https://d.la1-core2.sfdc-lywfpd.salesforceliveagent.com/chat',
                    eswLiveAgentDevName: 'Heartland_Sheds_Chat',
                    isOfflineSupportEnabled: true
                }
            );
        };

        if (!window.embedded_svc) {
            var s = document.createElement('script');
            s.setAttribute('src', 'https://backyardproducts.my.salesforce.com/embeddedservice/5.0/esw.min.js');
            s.onload = function() {
                initESW(null);
            };
            document.body.appendChild(s);
        } else {
            initESW('https://service.force.com');
        }
    };
});
if (window.location.pathname == '/collections/accessories' || window.location.pathname  == '/collections/packages') {
    window.location.href = `${window.location.origin}/collections/sheds`    
}
